import { BatteryType } from "../types/battery.type";

/** Час останнього збереження BMS; для старих записів без поля — `lastUpdatedAt`. */
export function getBatteryBmsDisplayTime(
  battery: BatteryType
): Date | string | undefined {
  return battery.bmsStateUpdatedAt ?? battery.lastUpdatedAt;
}
